import React, { createContext, useState, useEffect, useContext } from 'react';
import localStorage from 'local-storage';
import Client from 'shopify-buy';
import { useLanguage } from './LanguageContext';

export const defaultContext = {};

const ShopifyContext = createContext(defaultContext);

export const ShopifyProvider = ({ shopName, accessToken, children }) => {
  const { currency } = useLanguage();
  const [client, setClient] = useState();
  const [checkout, setCheckout] = useState();

  useEffect(() => {
    const newClient = Client.buildClient({
      domain: `${currency === 'DKK' ? 'bluli-dk' : 'bluli'}.myshopify.com`,
      storefrontAccessToken:
        currency === 'DKK' ? process.env.GATSBY_BLULI_DKK_ACCESS_TOKEN : process.env.GATSBY_BLULI_EUR_ACCESS_TOKEN,
    });

    setClient(newClient);
  }, [currency]);

  useEffect(() => {
    const checkoutId = localStorage('checkoutId');
    if (client && client.checkout) {
      if (checkoutId) {
        client.checkout.fetch(checkoutId).then((res) => {
          if (res) {
            setCheckout(res);
          } else {
            client.checkout.create().then((resp) => {
              localStorage('checkoutId', resp.id);
              setCheckout(resp);
            });
          }
        });
      } else {
        client.checkout.create().then((res) => {
          localStorage('checkoutId', res.id);
          setCheckout(res);
        });
      }
    }
  }, [client]);

  const addVariantToCart = async (variantId, quantity) => {
    const lineItemsToAdd = [{ variantId, quantity: parseInt(quantity, 10) }];
    const checkoutId = checkout.id;

    const res = await client.checkout.addLineItems(checkoutId, lineItemsToAdd);

    await setCheckout(res);

    return res;
  };

  const updateQuantityInCart = async (lineItemId, quantity) => {
    const checkoutId = checkout.id;
    const lineItemsToUpdate = [{ id: lineItemId, quantity }];

    // Update the line item on the checkout (change the quantity or variant)
    const res = await client.checkout.updateLineItems(checkoutId, lineItemsToUpdate);

    await setCheckout(res);

    return res;
  };

  const removeFromCart = async (lineItemId) => {
    const checkoutId = checkout.id;

    const res = await client.checkout.removeLineItems(checkoutId, [lineItemId]);

    await setCheckout(res);

    return res;
  };

  if (process.env.NODE_ENV === 'development') {
    console.group('ShopifyContext');
    console.log('ShopifyClient', client);
    console.log('CheckoutStatus', checkout);
    console.groupEnd();
  }

  return (
    <ShopifyContext.Provider value={{ checkout, client, addVariantToCart, updateQuantityInCart, removeFromCart }}>
      {children}
    </ShopifyContext.Provider>
  );
};

export const useShopify = () => {
  const shopify = useContext(ShopifyContext);

  return shopify;
};

export default ShopifyContext;
